import { z } from "zod";

export const editEventSchema = z.object({
  absentMembers: z
    .array(
      z.object({
        "@id": z.string(),
        firstName: z.string(),
        lastName: z.string(),
      }),
    )
    .optional(),
  agenda: z
    .string()
    .max(255, "La description ne peut pas dépasser 255 caractères")
    .optional(),
});
